import React from 'react';
import Layout from '../../components/layout/Layout';
import Seo from '../../components/seo/Seo';
import WhyChooseSection from '../../components/why/WhyChooseSection';

export default function WhyUsPage() {
  return (
    <Layout>
      <Seo
        title="Why Neat Schedule"
        description="See why service businesses choose Neat Schedule for online booking, staff scheduling, client management, and real human support."
        canonicalPath="/why"
        keywords={[
          'why Neat Schedule',
          'appointment scheduling software',
          'service business software',
          'online booking platform',
        ]}
      />
      <WhyChooseSection />
    </Layout>
  );
}
